import useResource from 'app/hooks/useResource';

import {
  getAnalyticsReport,
  setAnalyticsReportParams
} from 'app/actions/reports';

import {
  analyticsReport as resource
} from 'app/resources';

const useAnalyticsReport = () => {
  return useResource({
    resource,
    getResource: getAnalyticsReport,
    setResourceParams: setAnalyticsReportParams
  });
}

export default useAnalyticsReport;
